import React from 'react';

import {
  Grid,
  SkeletonLoader,
  SkeletonText,
  Text,
} from '@zapier/design-system';

import { formatDateInUTC } from 'app/developer-v3/utils';

import CollapsibleMonitoringTable from './CollapsibleMonitoringTable';
import { EventType } from './types';

type Props = {
  events: Array<EventType>;
  isLoading: boolean;
};

function EventTable({ isLoading, events }: Props) {
  return (
    <Grid columns={1}>
      {isLoading && (
        <SkeletonLoader>
          <SkeletonText lines={3} size="body" />
        </SkeletonLoader>
      )}
      {!isLoading &&
        events &&
        (!events.length ? (
          <Text fontWeight={600}>
            No events found for this time period with the selected filters.
          </Text>
        ) : (
          <Text fontWeight={600}>
            Viewing events from{' '}
            {formatDateInUTC(events[events.length - 1].date)} to{' '}
            {formatDateInUTC(events[0].date)} (max 500)
          </Text>
        ))}
      {!isLoading && events && events.length > 0 && (
        <CollapsibleMonitoringTable events={events} />
      )}
    </Grid>
  );
}

export default EventTable;
